import { useEffect, useState } from "react";
import ModalView from "../../common/modal/index.js";
import DatePickerComponent from "../../common/date-picker/index.js";
import TextInput from "../../common/text-input/index.js";
import DropdownComponent from "../../common/dropdown-input/index.js";
import CommonButton from "../../common/button/button.js";
import Text from "../../common/typography/text.js";
import APIService from "../../Service/APIService.js";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import FailureIcon from "../../icons/failure-icon.js";
import moment from "moment";
import RightTopArrowIcon from "../../icons/right-top-arrow.js";
import { Button } from "antd";

const ApplyCommission = ({
  handleApplyCommModal,
  modalOpenApplyComm,
  invoiceData,
  invoiceCommissionData,
  invoiceHomeData,
  commContractAlert,
  commContractAlertData,
  distInvCommPercentage,
  isDistInvCommPercentageLoading = false,
}) => {
  // NEW MODULE
  const [statementMonthComm, setStatementMonthComm] = useState(null);
  const [appliedDate, setAppliedDate] = useState(null);
  const [invoiceTotalForm, setInvoiceTotalForm] = useState();
  const [invoiceCommForm, setInvoiceCommForm] = useState();
  const [paidTillDate, setPaidTillDate] = useState(0);
  const [currentCommApplied, setCurrentCommissionApplied] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [commAppliedError, setCommAppliedError] = useState();
  const [manuCommRateError, setManuCommRateError] = useState(false);
  const [commAppliedForm, setCommAppliedForm] = useState(0);
  const [manuCommRateForm, setManuCommRateForm] = useState();
  const [existingCommissions, setExistingCommissions] = useState(null);
  const [isApplyToProductsClick, setIsApplyToProductsClick] = useState(false);
  const [invoicePostObj, setInvoicePostObj] = useState({});
  const [totalReceivedToday, setTotalReceivedToday] = useState(0);
  const [isApplied, setIsApplied] = useState(false);
  const [shippingPaidCommForm, setShippingPaidCommForm] = useState({});
  const [commRecvdForm, setCommRecvdForm] = useState();
  const [asCommissionMessage, setASCommissionMessage] = useState("");
  const [shippingCostCommForm, setShippingCostCommForm] = useState();
  const [shippingCostAssnCommForm, setShippingCostAssnCommForm] = useState();
  const [commAppliedProduct, setCommAppliedProduct] = useState(null);
  const [isApplyCommission, setIsApplyCommission] = useState(false);
  const [maxDateApplied, setMaxDateApplied] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [checkDistPercentageZero, setCheckDistPercentageZero] = useState(false);
  const [productGroup, setProductGroup] = useState("");
  const [isNonStandardManufContract, setIsNonStandardManufContract] =
    useState(false);
  const isRepeatCommission =
    invoiceHomeData?.invoice?.IsCommissionApplied === true;
  const distInvCommPercentageError =
    !Array.isArray(distInvCommPercentage) &&
    distInvCommPercentage?.error
      ? distInvCommPercentage?.message ||
        distInvCommPercentage?.data?.message ||
        "Unable to load distributor commission products."
      : "";

  useEffect(() => {
    if (invoiceData) {
      setInvoiceTotalForm(invoiceData?.InvoiceTotal);
      setShippingCostCommForm(invoiceData?.ShippingCost);
      setShippingCostAssnCommForm(invoiceData?.ShippingCostAssignedTo);
      if (invoiceData?.IsShippingCostPaid) {
        setShippingPaidCommForm({
          label: "Yes",
          value: "shipping-cost-paid-yes",
        });
      } else {
        setShippingPaidCommForm({
          label: "No",
          value: "shipping-cost-paid-no",
        });
      }
    }
    if (invoiceCommissionData) {
      // setCommAppliedForm(invoiceCommissionData?.CommissionApplied);
      setInvoiceCommForm(invoiceCommissionData?.RemainingBalance);
      setManuCommRateForm(invoiceCommissionData?.ManufacturerCommissionAS);
      // setCommRecvdForm(invoiceCommissionData?.CommissionReceived);
    }
    if (invoiceHomeData) {
      setInvoicePostObj({
        InvoiceID: invoiceHomeData?.invoice.ID,
        IsCommissionApplied: invoiceHomeData?.invoice.IsCommissionApplied,
        IsShippingCostPaid: invoiceHomeData?.invoice.IsShippingCostPaid,
        ShippingCostPaidAmount: invoiceHomeData?.invoice.ShippingCostPaidAmount,
        ShippingCost: invoiceHomeData?.invoice.ShippingCost,
        InvoiceDate: invoiceHomeData?.invoice.InvoiceDate,
        DistributorID: invoiceHomeData?.invoice.DistributorID,
      });
    }
  }, [invoiceData, invoiceCommissionData, invoiceHomeData]);

  const getExistingCommissionData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getinvoicecommissiontissues?InvoiceID=${invoiceData?.ID}`,
    );
    const apiRes = response.data.data;
    if (
      apiRes &&
      apiRes?.error &&
      apiRes?.distributorCommissionPercentage === 0
    ) {
      setCheckDistPercentageZero(true);
    }
    const res = response.data.data?.ResultArray;
    if (res && res.length > 0) {
      setProductGroup(res[0]?.ProductGroupName || "");
      const commAppliedTillDate = res.reduce(
        (acc, cur) => acc + (cur.PaidTillDate ?? 0),
        0,
      );
      setPaidTillDate(
        commAppliedTillDate + (invoiceData?.ShippingCostPaidAmount ?? 0),
      );
      setCurrentCommissionApplied(commAppliedTillDate);
      const totalReceived = res.reduce(
        (acc, cur) => acc + (cur.Received ?? 0),
        0,
      );
      const invoiceTotal = response.data.data?.InvoiceTotal ?? 0;
      const totalBalance =
        Number(invoiceTotal) +
        Number(invoiceHomeData.invoice.ShippingCost ?? 0) -
        Number(totalReceived) -
        Number(invoiceHomeData.invoice.ShippingCostPaidAmount ?? 0);
      setTotalBalance(totalBalance);
    }
    return response.data.data;
  };

  const [minDateApplied, setMinDateApplied] = useState(null);

  const getDateAppliedLimits = async () => {
    // return;
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("GetDateAppliedLimits");
    const maxDate = dayjs(response?.data?.data?.MaxEndDate);
    const minDate = dayjs(response?.data?.data?.MinStartDate);
    setMaxDateApplied(maxDate);
    setMinDateApplied(minDate);
    return { maxDate, minDate };
  };

  useEffect(() => {
    if (invoiceData?.ID) {
      getExistingCommissionData()
        .then((res) => {
          if (res && !res?.error) {
            setASCommissionMessage(res?.ASCommissionMessage ?? "");
            setExistingCommissions(res?.ResultArray);
            setManuCommRateForm(res?.ASCommissionPercentage ?? "");
            setIsNonStandardManufContract(
              res?.IsNonStandardManufContract ?? false,
            );
          }
        })
        .then(async () => {
          await getDateAppliedLimits();
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [invoiceData?.ID]);

  useEffect(() => {
    if (!invoiceData?.ID || !invoiceHomeData?.invoice) return;

    if (isRepeatCommission) {
      if (!Array.isArray(existingCommissions)) return;
      const tempResArray = existingCommissions.map((item) => ({
        ...item,
        ReceivedError: "",
        Received: 0,
      }));
      setCommAppliedProduct(tempResArray);
      return;
    }

    if (distInvCommPercentage == null) {
      setCommAppliedProduct(null);
      return;
    }

    if (!Array.isArray(distInvCommPercentage)) {
      setCommAppliedProduct([]);
      return;
    }

    const tempResArray = distInvCommPercentage.map((item) => ({
      ...item,
      ReceivedError: "",
      Received: 0,
    }));
    setCommAppliedProduct(tempResArray);
  }, [
    distInvCommPercentage,
    existingCommissions,
    invoiceData?.ID,
    invoiceHomeData?.invoice,
    isRepeatCommission,
  ]);

  const hasEligibleCommissionProducts = (commAppliedProduct?.length ?? 0) > 0;
  const hasLoadedCommissionProducts = isRepeatCommission
    ? Array.isArray(existingCommissions)
    : Array.isArray(distInvCommPercentage) || Boolean(distInvCommPercentageError);
  const showNoEligibleCommissionProducts =
    hasLoadedCommissionProducts &&
    !distInvCommPercentageError &&
    !hasEligibleCommissionProducts;

  const applyToProducts = () => {
    setIsApplyToProductsClick(true);
    let totalPaidTillDate = 0;
    let totalReceived = 0;
    if (invoiceData?.IsShippingCostPaid === false) {
      if (
        commAppliedForm >
        Number(shippingCostCommForm ?? 0) -
          Number(invoiceData?.ShippingCostPaidAmount ?? 0)
      ) {
        setInvoicePostObj({
          ...invoicePostObj,
          IsShippingCostPaid: true,
          ShippingCostPaidAmount: Number(shippingCostCommForm),
          IsCommissionApplied: true,
          CommissionReceived:
            Number(invoiceData?.CommissionReceived) + Number(commRecvdForm),
          ASCommissionPercentage: manuCommRateForm,
        });
      } else {
        setInvoicePostObj({
          ...invoicePostObj,
          IsShippingCostPaid: false,
          ShippingCostPaidAmount:
            Number(invoiceData?.ShippingCostPaidAmount) +
            Number(commAppliedForm),
          IsCommissionApplied: true,
          CommissionReceived:
            Number(invoiceData?.CommissionReceived) + Number(commRecvdForm),
          ASCommissionPercentage: manuCommRateForm,
        });
      }
      totalReceived =
        Number(commAppliedForm) -
        (Number(shippingCostCommForm ?? 0) -
          Number(invoiceData?.ShippingCostPaidAmount ?? 0));
      totalReceived = parseFloat(totalReceived.toFixed(2));
    } else {
      setInvoicePostObj({
        ...invoicePostObj,
        CommissionReceived: parseFloat(
          (
            Number(invoiceData?.CommissionReceived) + Number(commRecvdForm)
          ).toFixed(2),
        ),
      });
      totalReceived = Number(commAppliedForm).toFixed(2);
    }
    if (totalReceived > 0) {
      let total = Number(parseFloat(totalReceived).toFixed(2));
      let totalBalance = 0;
      const updatedProducts = [];
      for (let i = 0; i < commAppliedProduct.length; i++) {
        if (commAppliedProduct[i]?.Balance > 0) {
          const commToBePaid =
            Number(commAppliedProduct[i].Price) -
            Number(commAppliedProduct[i]?.PaidTillDate);
          // Number(commAppliedProduct[i]?.Received);
          let currentReceived = 0;
          let currentBalance = 0;
          if (commToBePaid > totalReceived) {
            currentReceived = totalReceived;
            totalReceived = 0;
          } else {
            currentReceived = commToBePaid;
            totalReceived -= commToBePaid;
          }
          currentBalance = commAppliedProduct[i]?.Balance - currentReceived;
          totalBalance += currentBalance;
          updatedProducts.push({
            ...commAppliedProduct[i],
            Received: Number(parseFloat(Number(currentReceived).toFixed(2))),
            Balance: Number(parseFloat(Number(currentBalance).toFixed(2))),
            PaidTillDate: Number(
              parseFloat(
                (
                  Number(currentReceived) +
                  Number(commAppliedProduct[i]?.PaidTillDate ?? 0)
                ).toFixed(2),
              ),
            ),
            PaidThisTime: currentReceived > 0 ? true : false,
          });
          totalPaidTillDate +=
            currentReceived + commAppliedProduct[i]?.PaidTillDate;
          totalPaidTillDate = Number(
            parseFloat(Number(totalPaidTillDate).toFixed(2)),
          );
        } else {
          updatedProducts.push({
            ...commAppliedProduct[i],
            PaidThisTime: false,
          });
        }
      }
      setTotalReceivedToday(total - totalReceived);
      setTotalBalance(totalBalance);
      let newArray = [];
      for (let i = 0; i < updatedProducts.length; i++) {
        newArray.push(updatedProducts[i]);
      }
      const tempResArray = newArray.map((item) => ({
        ...item,
        ReceivedError: "",
        DistributorCommissionPercentage: invoiceData?.IsNonStandard
          ? 0
          : item?.DistributorCommissionPercentage,
      }));
      setCommAppliedProduct(tempResArray);
    }
    setIsApplied(true);
    setPaidTillDate(
      (
        Number(totalPaidTillDate) +
        Number(invoiceHomeData.invoice?.ShippingCostPaidAmount ?? 0)
      ).toFixed(2),
    );
    setShippingPaidCommForm({ label: "Yes", value: "shipping-cost-paid-yes" });
  };

  const getStatementData = async (dateApp) => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `GetStatementDataForDateApplied?DateApplied=${dateApp}`,
    );

    return response?.data?.data;
  };

  const handleAppliedDateChange = async (date) => {
    setAppliedDate(date);

    const statementData = await getStatementData(date);

    if (statementData) {
      setStatementMonthComm(statementData?.StatementMonthYear);
    } else {
      setStatementMonthComm("NA");
    }
  };

  const handleManuCommRateChange = (e) => {
    setManuCommRateForm(e?.target?.value);
    setCommRecvdForm((Number(e.target.value) * Number(commAppliedForm)) / 100);
    if (e?.target?.value > 100) {
      setManuCommRateError("value should be < 100%");
    } else {
      setManuCommRateError("");
    }
  };

  const handleCommApplied = (e) => {
    const maxValueAllowed =
      Number(invoiceData?.InvoiceTotal) +
      Number(invoiceData?.ShippingCost) -
      Number(paidTillDate);

    setCommAppliedForm(e?.target?.value);
    setCommRecvdForm(
      (Number(e?.target?.value) * Number(manuCommRateForm)) / 100,
    );
    if (
      e?.target?.value >
      Number(invoiceData?.InvoiceTotal) +
        Number(invoiceData?.ShippingCost) -
        Number(paidTillDate)
    ) {
      setCommAppliedError(`Value should be less than ${maxValueAllowed}`);
    } else {
      setCommAppliedError("");
    }
  };

  const applyCommission = async () => {
    setIsLoading(true);
    const receivedSum = commAppliedProduct?.reduce(
      (sum, item) => sum + Number(item.Received || 0),
      0,
    );
    if (invoiceData?.IsShippingCostPaid) {
      if (
        Number(Number(commAppliedForm).toFixed(2)) -
          Number(Number(receivedSum).toFixed(2)) >
        0
      ) {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Commission Applied amount should be equal to the sum of Applied.`,
          confirmButtonText: "OK",
          confirmButtonColor: "#1dacff",
        });
        return;
      }
    } else {
      if (
        // Number(Number(commAppliedForm).toFixed(2)) - Number((Number(receivedSum).toFixed(2)) - Number((Number(shippingCostCommForm) - Number(invoiceData?.ShippingCostPaidAmount)).toFixed(2))) > 0
        Number(Number(commAppliedForm).toFixed(2)) -
          (Number(Number(receivedSum).toFixed(2)) +
            (
              Number(shippingCostCommForm) -
              Number(invoiceData?.ShippingCostPaidAmount ?? 0)
            ).toFixed(2)) >
        0
      ) {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Commission Applied amount should be equal to the sum of Applied.`,
          confirmButtonText: "OK",
          confirmButtonColor: "#1dacff",
        });
        return;
      }
    }
    // check is ReceivedError is empty in commAppliedProduct
    const hasReceivedError = commAppliedProduct.some(
      (item) => item.ReceivedError && item.ReceivedError !== "",
    );
    if (hasReceivedError) {
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please resolve all errors in the Applied field before applying commission.",
        confirmButtonText: "OK",
        confirmButtonColor: "#1dacff",
      });
      return;
    }
    setIsApplyCommission(true);
    const postArr = [];
    for (let i = 0; i < commAppliedProduct.length; i++) {
      const obj = {
        AccountID: commAppliedProduct[i].AccountID,
        AccountName: commAppliedProduct[i].AccountName,
        ManufacturerID: commAppliedProduct[i].ManufacturerID,
        ManufacturerName: commAppliedProduct[i].ManufacturerName,
        DistributorID: invoiceData.DistributorID,
        DistributorName: invoiceData.DistributorName,
        OrderID: invoiceData.OrderID,
        OrderType: invoiceData.OrderType,
        InvoiceID: invoiceData.ID,
        InvoiceNumber: invoiceData.InvoiceNumber,
        InvoiceDate: invoiceData.InvoiceDate,
        InvoiceTotal: invoiceData.InvoiceTotal,
        DateApplied: appliedDate,
        StatementMonth: statementMonthComm,
        ShippingCost: shippingCostCommForm,
        ShippingCostPaid: shippingPaidCommForm?.label,
        ShippingCostAssignedTo: shippingCostAssnCommForm,
        InvoiceProductID:
          commAppliedProduct[i].InvoiceProductID ?? commAppliedProduct[i].ID,
        TissueID: commAppliedProduct[i].TissueID,
        ProductGroupID: commAppliedProduct[i].ProductGroupID,
        ProductGroupName: commAppliedProduct[i].ProductGroupName,
        ProductID: commAppliedProduct[i]?.ProductID,
        ProductCode: commAppliedProduct[i].ProductCode,
        ProductName: commAppliedProduct[i].ProductName,
        Price: commAppliedProduct[i].Price,
        Received: commAppliedProduct[i].Received,
        Balance: commAppliedProduct[i].Balance,
        PaidTillDate: commAppliedProduct[i].PaidTillDate,
        PaidThisTime: commAppliedProduct[i].PaidThisTime,
        DistributorCommissionPercentage:
          commAppliedProduct[i].DistributorCommissionPercentage,
      };
      postArr.push(obj);
    }
    const postObj = {
      InvoiceUpdateData: invoicePostObj,
      CommissionData: postArr,
    };
    // return;
    const apiServe = new APIService();
    const response = await apiServe.addDataToBackend(
      postObj,
      "applycommission",
    );
    if (response?.data?.error === true) {
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.data.message || "Failed to apply commission!",
        confirmButtonText: "OK",
        confirmButtonColor: "#1dacff",
      });
      return;
    }
    if (response && response?.status === 200) {
      setIsLoading(false);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Commission applied successfully!",
        confirmButtonText: "OK",
        confirmButtonColor: "#1dacff",
      }).then(() => {
        window.location.reload();
      });
    } else {
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to apply commission!",
        confirmButtonText: "OK",
        confirmButtonColor: "#1dacff",
      });
    }
  };

  return (
    <ModalView
      isOpen={modalOpenApplyComm}
      onClose={handleApplyCommModal}
      isLoading={
        isLoading || (!isRepeatCommission && isDistInvCommPercentageLoading)
      }
      modalTitle="Apply Commission"
      textInputComponent={
        <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
          {commContractAlert || checkDistPercentageZero ? (
            <div className="modal-alert-container">
              <div className="modal-alert-content">
                <FailureIcon
                  className="delete-icon-container"
                  width={16}
                  height={16}
                />
                <Text>
                  {commContractAlertData?.ContractExists === false && (
                    <>
                      Commission cannot be applied to this invoice because no
                      valid commission contract exists for{" "}
                      {invoiceData?.DistributorName} on Invoice Date{" "}
                      {moment(invoiceData?.InvoiceDate).format("MM-DD-YYYY")}.
                      Please create a new commission contract to proceed.
                    </>
                  )}
                  {commContractAlertData?.ContractExists === true &&
                    commContractAlertData?.ContractProductExists === false && (
                      <>
                        Commission cannot be applied to this invoice because
                        product {commContractAlertData?.ProductGroupName} (ID:{" "}
                        {commContractAlertData?.ProductGroupID}) does not exist
                        in the commission contract (ID:{" "}
                        {commContractAlertData?.CommissionContractID}) for this
                        distributor. Please update the commission contract to
                        proceed.
                      </>
                    )}
                  {commContractAlertData?.ContractExists === true &&
                    commContractAlertData?.ContractProductExists === true &&
                    commContractAlertData?.CommissionZero === true && (
                      <>
                        Commission cannot be applied to this invoice because
                        product {commContractAlertData?.ProductGroupName} (ID:{" "}
                        {commContractAlertData?.ProductGroupID}) rate is set at
                        0% in the commission contract (ID:{" "}
                        {commContractAlertData?.CommissionContractID}) for this
                        distributor. Please update the commission contract to
                        proceed.
                      </>
                    )}
                </Text>
              </div>
            </div>
          ) : (
            <>
              {(invoiceCommissionData?.IsNonStandard ||
                (existingCommissions &&
                  existingCommissions.length > 0 &&
                  existingCommissions[0]?.IsNonStandard)) && (
                <div className="modal-alert-container">
                  <div className="modal-alert-content">
                    <FailureIcon
                      className="delete-icon-container"
                      width={16}
                      height={16}
                    />
                    <Text>
                      Distributor commission contract found for this invoice is
                      marked as Non-Standard. Please enter the commission rates
                      manually.
                    </Text>
                  </div>
                </div>
              )}
              {isNonStandardManufContract && (
                <div className="modal-alert-container">
                  <div className="modal-alert-content">
                    <FailureIcon
                      className="delete-icon-container"
                      width={16}
                      height={16}
                    />
                    <Text>
                      Manufacturer contract found for this invoice is marked as
                      Non-Standard. Please enter the commission rates manually.
                    </Text>
                  </div>
                </div>
              )}
              <div className="field-group-wrapper">
                <div className="field-group">
                  <DatePickerComponent
                    format="MM-DD-YYYY"
                    titleText="Date Applied"
                    isRequired
                    disabledDate={(currentDate) => {
                      // Disable if before minDateApplied or after maxDateApplied
                      if (!minDateApplied || !maxDateApplied) return true;
                      return (
                        currentDate.isBefore(minDateApplied.startOf("day")) ||
                        currentDate.isAfter(maxDateApplied.endOf("day"))
                      );
                    }}
                    value={appliedDate}
                    onChange={handleAppliedDateChange}
                  />
                  <TextInput
                    titleText="Statement Month"
                    placeholder="Statement Month"
                    isRequired
                    value={statementMonthComm}
                    setValue={setStatementMonthComm}
                    isDisabled
                  />
                </div>
                <div className="field-group">
                  <TextInput
                    titleText="Invoice Total"
                    placeholder="Invoice Total"
                    isRequired
                    isDisabled
                    value={invoiceTotalForm}
                    setValue={setInvoiceTotalForm}
                  />
                  <TextInput
                    titleText="Invoice Commission Balance"
                    placeholder="Invoice Commission Balance"
                    isRequired
                    isDisabled
                    value={invoiceCommForm}
                    setValue={setInvoiceCommForm}
                  />
                </div>
                <div className="field-group">
                  <TextInput
                    titleText="Commission Applied"
                    placeholder="Commission Applied"
                    isRequired
                    type="number"
                    maxValue={
                      Number(invoiceData?.InvoiceTotal) +
                      Number(invoiceData?.ShippingCost) -
                      Number(paidTillDate)
                    }
                    errorText={commAppliedError}
                    value={commAppliedForm}
                    onChange={handleCommApplied}
                  />
                  <TextInput
                    titleText="Manufacturer Commission Rate"
                    placeholder="Manufacturer Commission Rate"
                    isRequired
                    type="number"
                    maxValue={100}
                    value={manuCommRateForm}
                    onChange={handleManuCommRateChange}
                    helperText={asCommissionMessage}
                    errorText={manuCommRateError}
                    isDisabled={invoiceData?.IsCommissionApplied}
                  />
                  <TextInput
                    titleText="Commission Received"
                    placeholder="Commission Received"
                    isRequired
                    isDisabled
                    value={commRecvdForm}
                    setValue={setCommRecvdForm}
                  />
                </div>
                <div className="field-group">
                  <TextInput
                    titleText="Shipping Cost"
                    placeholder="Shipping Cost"
                    isRequired
                    isDisabled
                    value={shippingCostCommForm}
                    setValue={setShippingCostCommForm}
                  />
                  {/* <DropdownComponent
                  label="Shipping Cost Paid"
                  placeholder="Shipping Cost Paid"
                  isRequired
                  options={[
                    { label: "Yes", value: "shipping-cost-paid-yes" },
                    { label: "No", value: "shipping-cost-paid-no" },
                  ]}
                  value={shippingPaidCommForm}
                  isDisabled
                  // setValue={setShippingPaidCommForm}
                /> */}
                  <TextInput
                    titleText="Shipping Cost Paid"
                    placeholder="Shipping Cost Paid"
                    isRequired
                    isDisabled
                    value={shippingPaidCommForm}
                    // setValue={setShippingCostCommForm}
                  />
                  <DropdownComponent
                    label="Shipping Cost Assigned To"
                    placeholder="Shipping Cost Assigned To"
                    isRequired
                    options={[
                      { label: "Distributor", value: "distributor" },
                      {
                        label: "Advanced Solution",
                        value: "advanced-solution",
                      },
                    ]}
                    isDisabled
                    value={shippingCostAssnCommForm}
                    setValue={setShippingCostAssnCommForm}
                  />
                </div>
                <CommonButton
                  variant="table"
                  subVariant="primary"
                  style={{ width: "137px" }}
                  onClick={applyToProducts}
                  disabled={
                    !hasEligibleCommissionProducts ||
                    !commAppliedForm ||
                    commAppliedError ||
                    !appliedDate ||
                    isApplyToProductsClick
                  }
                >
                  Apply To Products
                </CommonButton>
                {isApplyToProductsClick && (
                  <Text variant="tinyText">
                    ${commAppliedForm} was applied to products
                  </Text>
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    alignSelf: "stretch",
                    gap: "32px",
                  }}
                >
                  <Text>Commissions Applied by Product</Text>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "8px",
                    }}
                  >
                    <Text variant="tinyText" color="lightText">
                      Remaining
                    </Text>
                    <Text>
                      $
                      {Number(commAppliedForm) > 0
                        ? (() => {
                            const receivedSum = commAppliedProduct?.reduce(
                              (sum, item) =>
                                (sum ?? 0) + Number(item.Received || 0),
                              0,
                            );
                            const shippingAdjustment =
                              invoiceData.IsShippingCostPaid === false
                                ? Number(shippingCostCommForm ?? 0) -
                                  Number(
                                    invoiceData?.ShippingCostPaidAmount ?? 0,
                                  )
                                : 0;
                            const rem =
                              Number(commAppliedForm) -
                              Number(receivedSum) -
                              shippingAdjustment;
                            const nonNegativeRem = Math.max(rem, 0);
                            return nonNegativeRem.toLocaleString("en-US", {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            });
                          })()
                        : "0.00"}
                    </Text>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px",
                    alignSelf: "stretch",
                  }}
                >
                  {distInvCommPercentageError && (
                    <Text color="lightText">{distInvCommPercentageError}</Text>
                  )}
                  {showNoEligibleCommissionProducts && (
                    <Text color="lightText">
                      No eligible invoice products remain on this invoice for
                      commission application.
                    </Text>
                  )}
                  {commAppliedProduct?.map((comm, idx) => {
                    // Calculate maxValue for "Applied" input
                    const appliedSum = commAppliedProduct.reduce(
                      (sum, item, i) =>
                        i !== idx ? sum + Number(item.Received || 0) : sum,
                      0,
                    );
                    let maxValue = Number(commAppliedForm || 0) - appliedSum;
                    if (invoiceData?.IsShippingCostPaid === false) {
                      maxValue =
                        Number(maxValue) -
                        (Number(shippingCostCommForm) -
                          Number(invoiceData?.ShippingCostPaidAmount ?? 0));
                    }
                    if (maxValue < 0) {
                      maxValue = 0; // Ensure maxValue is not negative
                    }
                    maxValue = Number(parseFloat(maxValue).toFixed(2));

                    return (
                      <div
                        className="field-group-wrapper"
                        key={comm?.InvoiceProductID || comm?.ID || idx}
                      >
                        <div className="field-group">
                          <TextInput
                            titleText="TissueID"
                            placeholder="TissueID"
                            isRequired
                            isDisabled
                            value={comm?.TissueID ?? ""}
                          />
                          <TextInput
                            titleText="Cost"
                            placeholder="Cost"
                            isRequired
                            isDisabled
                            value={comm?.Price}
                          />
                          <TextInput
                            titleText="Applied Till Date"
                            placeholder="Applied Till Date"
                            // isRequired
                            isDisabled
                            value={comm?.PaidTillDateOg}
                          />
                          <TextInput
                            titleText="Applied"
                            placeholder="Applied"
                            isRequired
                            type="number"
                            value={comm?.Received}
                            maxValue={maxValue}
                            errorText={comm?.ReceivedError}
                            onChange={(e) => {
                              const prevValue = Number(comm?.Received) || 0;
                              const newValue = Number(e.target.value);
                              // set the value of ReceievedError in commAppliedProduct
                              if (newValue < 0 || newValue > maxValue) {
                                setCommAppliedProduct((prev) =>
                                  prev.map((item, i) =>
                                    i === idx
                                      ? {
                                          ...item,
                                          ReceivedError: "Invalid value",
                                        }
                                      : item,
                                  ),
                                );
                              } else {
                                setCommAppliedProduct((prev) =>
                                  prev.map((item, i) =>
                                    i === idx
                                      ? { ...item, ReceivedError: "" }
                                      : item,
                                  ),
                                );
                              }
                              setCommAppliedProduct((prev) =>
                                prev.map((item, i) =>
                                  i === idx
                                    ? {
                                        ...item,
                                        Received: newValue,
                                        PaidTillDate:
                                          Number(item.PaidTillDate ?? 0) -
                                          prevValue +
                                          newValue,
                                        Balance:
                                          Number(item?.Price ?? 0).toFixed(2) -
                                          Number(
                                            item?.PaidTillDateOg ?? 0,
                                          ).toFixed(2) -
                                          Number(newValue ?? 0).toFixed(2),
                                        PaidThisTime:
                                          newValue > 0 ? true : false,
                                      }
                                    : item,
                                ),
                              );
                            }}
                          />
                          <TextInput
                            titleText="Balance"
                            placeholder="Balance"
                            isRequired
                            isDisabled
                            value={comm?.Balance}
                          />
                          <TextInput
                            titleText="Distributor Percentage"
                            placeholder="DistributorPercentage"
                            type="number"
                            isRequired
                            // isDisabled={invoiceCommissionData.IsNonStandard ? false : true}
                            value={comm?.DistributorCommissionPercentage}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setCommAppliedProduct((prev) =>
                                prev.map((item, i) =>
                                  i === idx
                                    ? {
                                        ...item,
                                        DistributorCommissionPercentage:
                                          newValue,
                                      }
                                    : item,
                                ),
                              );
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      }
      footerButtonWrapper={
        <div className="footer-button-wrapper">
          {commContractAlert || checkDistPercentageZero ? (
            <a
              href="/CommissionContract"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
            >
              <CommonButton
                variant="table"
                subVariant="primary"
                icon={<RightTopArrowIcon />}
              >
                Create New Commission Contract
              </CommonButton>
            </a>
          ) : (
            <>
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={applyCommission}
                disabled={!isApplied || !hasEligibleCommissionProducts}
              >
                Apply Commission
              </CommonButton>
            </>
          )}
        </div>
      }
    />
  );
};

export default ApplyCommission;
